import './FieldError.css'

import { ReactNode } from 'react'

import { cx } from '../utilities/cx'
import { fieldFlagHoc, FieldFlagHocProps } from './FieldFlagHoc'

export type FieldErrorProps = Omit<FieldFlagHocProps, 'flag'> & {
  flag?: string
  text: Record<string, string> | string
}

export const FieldError = (props: FieldErrorProps) => {
  const isSingular = typeof props.text === 'string'
  const flags = isSingular ? [props.flag!] : Object.keys(props.text)
  const text = isSingular
    ? { [props.flag!]: props.text as string }
    : (props.text as Record<string, string>)
  return <FieldErrorInner {...props} flag={flags} text={text} />
}

export type FieldErrorInnerProps = {
  className?: string
  text: Record<string, string>
  children?: ReactNode
}

const FieldErrorInner = fieldFlagHoc<FieldErrorInnerProps>({ erroring: true }, (props) => {
  const { className, activeFlags, text, children } = props
  const currentText = text[activeFlags[0]!] ?? ''

  return (
    <div className={cx('field-error', { 'field-error--active': !!currentText }, className)}>
      <div className="field-error__text">{currentText || '\u00A0'}</div>
      {children}
    </div>
  )
})
